import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { IonImg, IonLabel } from '@ionic/angular/standalone';
import { SlipType } from '../student-slip-modal.store';

@Component({
  selector: 'app-slip-type',
  templateUrl: './slip-type.component.html',
  styleUrls: ['./slip-type.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [IonImg, IonLabel]
})
export class SlipTypeComponent {
  private modelBacking: string;
  @Input()
  public get slipType(): string {
    return this.modelBacking;
  }
  public set slipType(value: string) {
    this.modelBacking = value;
    this.type = this.getSlipType(value);
    this.icon = this.getSlipIcon(value);
  }

  icon: string;
  type: SlipType;
  private getSlipType(slipType: string): SlipType {
    if (slipType === 'trip') return 'trip';
    if (slipType === 'consent') return 'consent';
    if (slipType === 'item') return 'item';
    return 'slip';
  }

  private getSlipIcon(slipType: string): string {
    if (slipType === 'trip') return '/assets/icon/trip-icon.svg';
    if (slipType === 'consent') return '/assets/icon/consent-icon.svg';
    if (slipType === 'item') return '/assets/icon/price-tag-icon.svg';
    return '/assets/icon/slip-icon.svg';
  }
}
